import styled, { css } from "styled-components";

import BIMClassCardContainer from "../bimClass/BIMClassCardContainer";

const StyledBC = styled(BIMClassCardContainer)`
    align-items: baseline;
    flex-direction: row;
    padding: 0;
`;

export default function ComponentTypeCard(props) {
    const { bimClassID, name, ...restProps } = props;

    return (
        <Styled
            as={ props.onClick ? "button" : "div" }
            { ...restProps }
        >
            <span className="name">{ name }</span>
            <div className="bimclasses">
                {
                    bimClassID && (
                        <StyledBC id={ bimClassID } />
                    )
                }
            </div>
        </Styled>
    );
}

const Styled = styled.button`
    align-items: flex-start;
    background: transparent;
    color: #000;
    border: 1px solid transparent;
    border-radius: 2px;
    cursor: default;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px 24px 8px 16px;
    transition: 200ms;

    .name {
        font-size: 1.6em;
        font-family: var(--font-mono), monospace;
        letter-spacing: -.04em;
    }

    .bimclasses {
        display: flex;
        flex-direction: row;
        font-size: .5em;

         & > span {
             font-size: 2em;
         }
    }

    ${ ({ onClick }) => onClick && CSSClickable }

    ${ ({ selected }) => selected && "color: #44c" }
`;

const CSSClickable = css`
    cursor: pointer;

    &:hover {
        & > .name {
            text-decoration: underline;
        }
    }
`;
